<template>
	<div v-if="activities" class="py-8 pl-2 max-w-7xl mx-auto">
		<Timeline :value="allActivities" class="-ml-[100%]">
			<template #content="slotProps">
				<HistoryTimelineCard :item="slotProps.item" :index="slotProps.index"/>
			</template>
		</Timeline>
	</div>
</template>

<script>
import { mapStores } from "pinia";
import { useAssetsStore } from "@/stores/assets.js";
import HistoryTimelineCard from "@/Components/HistoryTimelineCard.vue";

export default {
	name: "AssetHistoryView",
	components: {HistoryTimelineCard},
	data() {
		return {
			activities: undefined,
		}
	},
	computed: {
		...mapStores(useAssetsStore),
		allActivities() {
			return [
				...this.activities,
			].sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));
		},
	},
	methods: {
		async refreshAsset() {
			return this.assetsStore.showAsset(this.$route.params.asset, {
				fields: {assets: 'id'},
				include: ['activities.causer'],
			});
		},
	},
	watch: {
		'$route.params.asset': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.asset === 'NEW') {
						this.activities = [];
					} else {
						const response = (await this.refreshAsset());
						this.activities = response.activities;
					}
				} else {
					this.activities = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>